import {
  linksApi,
  TLinksApiTags,
} from '@/shared/redux/api/assets/links/links-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';
import { capitalizeString } from '@/shared/utils/format';

export const useInvalidateLinkTags = () => {
  const dispatch = useAppDispatch();

  const invalidateLinkTags = (payload?: any) => {
    const sourceTagType = capitalizeString(
      payload?.sourceType,
    ) as TLinksApiTags;
    const destinationTagType = capitalizeString(
      payload?.destinationType,
    ) as TLinksApiTags;

    dispatch(
      linksApi.util.invalidateTags([
        { type: sourceTagType, id: payload?.sourceId },
        { type: sourceTagType, id: 'LIST' },
        { type: destinationTagType, id: payload?.destinationId },
        { type: destinationTagType, id: 'LIST' },
      ]),
    );
  };

  return {
    invalidateLinkTags,
  };
};
